RivalIQ.apps.Admin.module('controllers', function (controllers, Admin, Backbone, Marionette, $, _, async) {

    'use strict';

    const Company = Admin.apps.Company;

    controllers.Router = Marionette.AppRouter.extend({
        appRoutes: {
            'users': 'userRoute',
            'companies': 'companyRoute',
            'companies/:id/edit': 'companyEditRoute',
            'queries': 'queriesRoute',
            'queries/:id': 'queryRoute',
            '*actions': 'redirectToMainRoute'
        }
    });

    const Controller = controllers.Controller = Marionette.Controller.extend({

        start: function (options) {
            const me = this;

            me.adminEditingProperties = options.adminEditingProperties;
            me.router = options.router;

            me.listenTo(Company, 'company:delete', me.showCompanyDeleteModal);
        },

        showUsers: function () {
            const me = this;
            Admin.accountTab.showLoading();

            const collection = new Admin.collections.Users();

            me.userContent = new Admin.apps.Account.views.Users({
                collection: collection,
                adminEditingProperties: me.adminEditingProperties
            });

            Admin.accountTab.show(me.userContent);
        },

        showCompanyEdit: function (model) {
            const me = this;

            Admin.editTab.showLoading();

            model.fetch().done(function () {
                me.companyContent = new Admin.apps.Company.views.Edit({
                    model: model
                });
                Admin.editTab.show(me.companyContent);
            });
        },

        showCompanies: function () {
            const collection = new Backbone.Collection();

            Admin.editTab.showLoading();

            Admin.editTab.show(new Admin.apps.Company.views.CompanySearch({
                collection: collection
            }));
        },

        showQueries: function () {
            const collection = new Admin.collections.Queries();

            Admin.queryTab.showLoading();

            const deferred = async.callbackToDeferred(function (error) {
                if (error) {
                    return Admin.queryTab.showError();
                }

                Admin.queryTab.show(new Admin.apps.Query.views.Queries({
                    collection: collection
                }));
            });

            collection.fetch().done(deferred.resolve).fail(deferred.reject);
        },

        showQuery: function (model) {
            const me = this;

            Admin.queryTab.showLoading();

            model.fetch().done(function () {
                me.queryContent = new Admin.apps.Query.views.Query({
                    model: model
                });
                Admin.queryTab.show(me.queryContent);
            }).fail(function () {
                Admin.queryTab.showError();
            });
        },

        /*
         * ROUTING
         */
        redirectOnError: function (callback) {
            const me = this;
            return async.callbackToDeferred(function (error) {
                if (error) {
                    me.redirectToMainRoute();
                    return RivalIQ.execute('alert:danger', 'An error occurred loading the page');
                }
                callback();
            });
        },

        redirectToMainRoute: function () {
            const me = this;
            me.router.navigate('/users', {
                trigger: true
            });
        },

        userRoute: function () {
            const me = this;

            me.showTab('/users');

            if (!me.userContent) {
                me.showUsers();
            }
        },

        companyRoute: function () {
            const me = this;

            me.showTab('/companies');
            me.showCompanies();
        },

        companyEditRoute: function (id) {
            const me = this;
            const model = new Admin.models.Company({
                id: id
            });

            Admin.editTab.showLoading();

            model.lock().done(function () {
                me.showCompanyEdit(model);
            }).fail(function () {
                // TODO update alert msg with more info
                RivalIQ.execute('alert:warning', 'Could not aquire edit lock');
                me.router.navigate('/companies', {
                    trigger: true
                });
            });
        },

        queriesRoute: function () {
            const me = this;

            me.showTab('/queries');
            me.showQueries();
        },

        queryRoute: function (queryId) {
            const me = this;

            const model = new Admin.models.Query({
                id: queryId
            });
            me.showTab('/queries');
            me.showQuery(model);
        },

        showTab: function (tab) {
            $('.nav li').removeClass('current');
            $(`.nav [href="#${tab}"]`).tab('show');
        }

    });

    controllers.addInitializer(function (options) {
        const controller = new Controller();
        options.router = new controllers.Router({
            controller: controller
        });
        controller.start(options);
    });

}, RivalIQ.utils.async);
